import * as React from 'react';
import {Alert} from '@material-ui/lab';
import {Element, scroller} from "react-scroll";

interface IProps {
    resultSuccessful: boolean;
}

function scrollToTopOfResults() {
    scroller.scrollTo("insurance-plan-result", {
        delay: 0,
        duration: 800,
        offset: -250,
        smooth: "easeInOutQuart",
    });
}

class InsurancePlanResult extends React.Component<IProps> {
    constructor(props: IProps) {
        super(props);
    }

    public render() {
        return (
            <div>
                <br/>
                <p style={{
                    border: '3px solid lightgray',
                    padding: '5px',
                    whiteSpace: "pre-wrap",
                    wordBreak: "normal",
                    wordWrap: "break-word"
                }}>

                    {this.props.resultSuccessful &&
                    <Alert variant="filled" severity="info">
                        Message sent! Due to backend async processes, insurance will not be ready for
                        about another 1 minute.
                    </Alert>}

                    {this.props.resultSuccessful && scrollToTopOfResults()}

                    <Element name="insurance-plan-result"/>
                </p>
            </div>
        );
    }
}

export default InsurancePlanResult;
